import { clsx } from 'clsx'

import { ReportCategory } from '@tribeplatform/gql-client/types'
import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

export type ReportCategoryItem = {
  text: string
  value: ReportCategory
}

interface Props {
  onChange: (value: ReportCategoryItem | null) => void
  value: ReportCategoryItem | null
  className?: string
}

export const ReportCategoryDropdown = (props: Props) => {
  const { $t } = useI18n()
  const { onChange, className, value } = props

  const reportCategoryItems: ReportCategoryItem[] = [
    {
      value: ReportCategory.HARASSMENT,
      text: $t({
        defaultMessage: 'Harassment or hate speech',
        id: 'ReportCategory.Harassment.Title',
      }),
    },
    {
      value: ReportCategory.SPAM,
      text: $t({
        defaultMessage: 'Spam',
        id: 'ReportCategory.Spam.Title',
      }),
    },
    {
      value: ReportCategory.MISINFORMATION,
      text: $t({
        defaultMessage: 'Misinformation',
        id: 'ReportCategory.Misinformation.Title',
      }),
    },
    {
      value: ReportCategory.VIOLENCE,
      text: $t({
        defaultMessage: 'Harmful activities',
        id: 'ReportCategory.Harmful.Title',
      }),
    },
    {
      value: ReportCategory.NUDITY,
      text: $t({
        defaultMessage: 'Adult content',
        id: 'ReportCategory.Adult.Title',
      }),
    },
  ]

  return (
    <Dropdown className={clsx(className, 'w-fit min-w-[15rem] self-end')}>
      <Dropdown.Button
        leadingIcon={<SvgIcon name="account-setting" />}
        as="div"
        className="cursor-pointer"
      >
        {value
          ? value.text
          : $t({
              defaultMessage: 'All categories',
              id: 'ReportCategory.AllReportCategories',
            })}
      </Dropdown.Button>
      <Dropdown.Items className="min-w-[15rem]">
        <Dropdown.Item onClick={() => onChange(null)}>
          <T
            defaultMessage="All categories"
            id="ReportCategory.AllReportCategories"
          />
        </Dropdown.Item>
        <Dropdown.Divider />
        {reportCategoryItems.map(item => (
          <Dropdown.Item onClick={() => onChange(item)} key={item.value}>
            {item.text}
          </Dropdown.Item>
        ))}
      </Dropdown.Items>
    </Dropdown>
  )
}
